import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import ErrorBoundary from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import About from "@/pages/About";
import NokChhonk from "@/pages/NokChhonk";
import Mozekaql from "@/pages/Mozekaql";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <div className="relative min-h-screen bg-[#080C14] text-slate-200">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/nokchhonk" element={<NokChhonk />} />
                <Route path="/mozekaql" element={<Mozekaql />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </main>
            <Footer />
            <div className="grain" aria-hidden="true" />
          </div>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </ErrorBoundary>
  );
}

export default App;
